export const SET_IDENTITIES = 'app/MasterContainer/SET_IDENTITIES';
export const REQUEST_CHANNELTIVITY_LOGIN =
  'app/MasterDashboard/REQUEST_CHANNELTIVITY_LOGIN';
